(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["engagement-ring-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll('.needs-validation');

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        'submit',
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add('was-validated');
        },
        false,
      );
    });

    // Set COMPLETE_URL field
    const hiddenInput = document.querySelector('input[name="COMPLETE_URL"]');
    if (hiddenInput) {
      hiddenInput.value = addSuccessQueryToURL(window.location.href);
    }
  })();

  function addSuccessQueryToURL(url) {
    const urlObj = new URL(url);
    urlObj.searchParams.set('success', 'true');
    return urlObj.toString();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mux-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('.mux-video--inner-wrapper[data-section-id]');

    if (!wrapper) {
      return;
    }

    if (wrapper.getAttribute('data-play-on-intersect') !== "true") {
      return;
    }

    const sectionId = wrapper.getAttribute('data-section-id');
    const selector = `.mux-video--inner-wrapper#${sectionId} mux-player`;
    const player = document.querySelector(selector);

    if (player) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // The video is in the viewport, resume playing
              player.play();
            } else {
              // The video is out of the viewport, pause playing
              player.pause();
            }
          });
        },
        { threshold: 0.5 },
      ); // 0.5 means the callback will be executed when at least half of the element is visible

      // Start observing the Mux player element
      observer.observe(player);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["refill-and-go"] && !Shopify.designMode) return;
  try {
    
  function adjustFontSize() {
    const h1 = document.querySelector('h1.section-title span');
    const parent = h1.parentElement;

    // Reset font size to a large value
    h1.style.fontSize = '200px';


    // Reduce font size until text fits without wrapping
    while (h1.offsetWidth > parent.offsetWidth) {
      let fontSize = parseFloat(window.getComputedStyle(h1).fontSize);
      h1.style.fontSize = fontSize - 1 + 'px';
    }
  }

  // Call the function initially
  document.addEventListener('DOMContentLoaded', function () {
    adjustFontSize();
  });

  // Add event listener for window resize
  window.addEventListener('resize', adjustFontSize);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wedding-ring-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll('.needs-validation');

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        'submit',
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add('was-validated');
        },
        false,
      );
    });

    // Set COMPLETE_URL field
    const hiddenInput = document.querySelector('input[name="COMPLETE_URL"]');
    if (hiddenInput) {
      hiddenInput.value = addSuccessQueryToURL(window.location.href);
    }
  })();

  function addSuccessQueryToURL(url) {
    const urlObj = new URL(url);
    urlObj.searchParams.set('success', 'true');
    return urlObj.toString();
  }

  } catch(e) { console.error(e); }
})();
})();
